module.exports = __webpack_public_path__ + "2b124309056b173acbd372878dff7ab5.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/map/8.png
// module id = 1355
// module chunks = 0